/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_IntroInputs */

const en_guide_json_vs_yaml_xml_intro = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choosing the right data format can significantly impact developer productivity and application performance. JSON, YAML, and XML are the three most widely used structured data formats, each with distinct strengths. This guide helps you make an informed choice for your specific use case.`)
};

const ko_guide_json_vs_yaml_xml_intro = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`올바른 데이터 포맷을 선택하면 개발자 생산성과 애플리케이션 성능에 큰 영향을 미칠 수 있습니다. JSON, YAML, XML은 가장 널리 사용되는 세 가지 구조화된 데이터 포맷으로, 각각 고유한 강점을 가지고 있습니다. 이 가이드는 특정 사용 사례에 맞는 현명한 선택을 도와줍니다.`)
};

const ja_guide_json_vs_yaml_xml_intro = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`適切なデータ形式を選ぶことは、開発者の生産性とアプリケーションのパフォーマンスに大きく影響します。JSON、YAML、XMLは最も広く使用されている3つの構造化データ形式で、それぞれに異なる強みがあります。このガイドでは、ユースケースに応じた最適な選択を支援します。`)
};

/**
* | output |
* | --- |
* | "Choosing the right data format can significantly impact developer productivity and application performance. JSON, YAML, and XML are the three most widely use..." |
*
* @param {Guide_Json_Vs_Yaml_Xml_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_intro = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_intro(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_intro(inputs)
	return ja_guide_json_vs_yaml_xml_intro(inputs)
});